module.exports = __webpack_public_path__ + "img/id.f495fa84.png";